import { KWELLO_ICON, KwelloSvgIcon } from '../../components/icon/KwelloSvgIcon';
import Footer from './Footer';
import { SignIn } from './SignIn';
import { LearnMore } from './LearnMore';
import { useDispatch } from 'react-redux';
import { clearConfig } from 'common/store/slices/page-config.slice';
import { useEffect } from 'react';

function Authentication() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearConfig());
  }, [dispatch]);

  return (
    <>
      <div className="authentication-container">
        <div className="triangles">
          <KwelloSvgIcon icon={KWELLO_ICON.LOGIN_TRIANGLES} />
        </div>
        <div className="section">
          <span className="kwello-icon">
            <KwelloSvgIcon icon={KWELLO_ICON.KWELLO_LOGO} />
          </span>
          <SignIn />
        </div>
        <div className="section">
          <LearnMore />
          <div className="rectangle" />
        </div>
      </div>
      <Footer fixed={true} />
    </>
  );
}

export default Authentication;
